<template>
  <div class="app-container">
    <!-- 搜索条件 -->
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="支付编号">
        <el-input placeholder="请输入支付编号" v-model="filter.pay_no" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属商户">
        <el-input placeholder="请输入所属商户" v-model="filter.merchant_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="分账收款方编号">
        <el-input placeholder="请输入分账收款方编号" v-model="filter.payee_no" clearable></el-input>
      </el-form-item>
      <el-form-item label="分账收款方名称">
        <el-input placeholder="请输入分账收款方名称" v-model="filter.payee_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select class="selScale" v-model="filter.status" style="width: 130px">
          <el-option label="--全部--" value=""></el-option>
          <el-option label="已分账" value="1"></el-option>
          <el-option label="未分账" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="filter.dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <!-- 结算支付记录列表 -->
    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="支付编号" prop="pay_no" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属商户" prop="merchant_name" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账收款方编号" prop="payee_no" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="分账收款方名称" prop="payee_name" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="结算编号" prop="settle_no" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="支付金额" align="right" width="120">
        <template slot-scope="{ row }">
          <span class="pay-amount">{{ formatAmount(row.pay_amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="扫码富订单号" prop="sacc_order_no" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="是否回调" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="isCallback(row) ? 'success' : 'info'">{{ isCallback(row) ? "是" : "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="isShared(row) ? 'success' : 'warning'">{{ statusText(row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="170" align="center"></el-table-column>
      <el-table-column label="更新时间" prop="update_time" width="170" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="90" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <!-- 当前搜索条件下的支付金额汇总 -->
      <div class="statistic_left">
        <span class="sbox">
          总支付金额：<span class="bold ssuc">{{ formatAmount(totalPayAmount) }} 元</span>
        </span>
      </div>
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 结算支付详情 Drawer（只读） -->
    <el-drawer
      title="结算支付详情"
      :visible.sync="visible.detail"
      direction="rtl"
      :size="drawerSize"
      @closed="onDetailClosed"
    >
      <div class="drawer-container">
        <div class="drawer-body" v-loading="detailLoading">
          <el-descriptions :column="2" border size="small" class="detail-desc">
            <el-descriptions-item label="支付编号">{{ detailData.pay_no || "-" }}</el-descriptions-item>
            <el-descriptions-item label="所属商户">{{ detailData.merchant_name || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账收款方编号">{{ detailData.payee_no || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账收款方名称">{{ detailData.payee_name || "-" }}</el-descriptions-item>
            <el-descriptions-item label="结算编号">{{ detailData.settle_no || "-" }}</el-descriptions-item>
            <el-descriptions-item label="支付金额">
              <span class="pay-amount">{{ formatAmount(detailData.pay_amount) }} 元</span>
            </el-descriptions-item>
            <el-descriptions-item label="扫码富订单号">{{ detailData.sacc_order_no || "-" }}</el-descriptions-item>
            <el-descriptions-item label="是否回调">{{ isCallback(detailData) ? "是" : "否" }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag size="small" :type="isShared(detailData) ? 'success' : 'warning'">
                {{ statusText(detailData) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="合作方订单号">{{ detailData.partner_order_no || "-" }}</el-descriptions-item>
            <el-descriptions-item label="产品大类">{{ detailData.product_type || "-" }}</el-descriptions-item>
            <el-descriptions-item label="转出商户号">{{ detailData.out_merchant_no || "-" }}</el-descriptions-item>
            <el-descriptions-item label="收款人类型">{{ detailData.payee_type || "-" }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ detailData.create_time || "-" }}</el-descriptions-item>
            <el-descriptions-item label="更新时间">{{ detailData.update_time || "-" }}</el-descriptions-item>
            <el-descriptions-item label="分账交易状态">{{ detailData.share_trade_status || "-" }}</el-descriptions-item>
            <el-descriptions-item label="返回编码">{{ detailData.ret_code || "-" }}</el-descriptions-item>
            <el-descriptions-item label="后台回调地址" :span="2">
              {{ detailData.callback_url || "-" }}
            </el-descriptions-item>
            <el-descriptions-item label="失败说明" :span="2">{{ detailData.fail_reason || "-" }}</el-descriptions-item>
            <el-descriptions-item label="返回内容" :span="2">
              <span class="ret-content">{{ detailData.ret_content || "-" }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="备注" :span="2">{{ detailData.remark || "-" }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="drawer-footer">
          <el-button type="primary" @click="visible.detail = false">关闭</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { GetSettlementPayRecordPageList, GetSettlementPayRecordDetail } from "@/api/finance"

export default {
  name: "SettlementPayRecord",
  mixins: [pageMixin],
  data() {
    return {
      tableData: [],
      loading: false,
      // 当前搜索条件下的总支付金额
      totalPayAmount: 0,
      filter: {
        pay_no: "",
        merchant_name: "",
        payee_no: "",
        payee_name: "",
        status: "",
        dateRange: []
      },
      visible: {
        detail: false
      },
      drawerSize: "50%",
      detailLoading: false,
      detailData: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    buildParams() {
      const [start_time, end_time] =
        this.filter.dateRange && this.filter.dateRange.length === 2 ? this.filter.dateRange : ["", ""]
      return {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        pay_no: this.filter.pay_no || null,
        merchant_name: this.filter.merchant_name || null,
        payee_no: this.filter.payee_no || null,
        payee_name: this.filter.payee_name || null,
        status: this.filter.status === "" ? null : this.filter.status,
        start_time: start_time || null,
        end_time: end_time || null
      }
    },

    getData() {
      this.loading = true
      GetSettlementPayRecordPageList(this.buildParams())
        .then((res) => {
          this.tableData = (res && res.data) || []
          this.pageParams.total = (res && (res.total || res.count)) || 0
          this.totalPayAmount = (res && res.total_pay_amount) || 0
        })
        .catch(() => {
          this.tableData = []
          this.pageParams.total = 0
          this.totalPayAmount = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    /* ============ 详情 ============ */
    onDetail(row) {
      this.detailData = { ...row }
      this.drawerSize = this.calcDrawerSize()
      this.visible.detail = true
      this.fetchDetail(row)
    },

    fetchDetail(row) {
      this.detailLoading = true
      GetSettlementPayRecordDetail({ ID: row.ID, pay_no: row.pay_no })
        .then((res) => {
          const detail = res && res.data ? res.data : {}
          this.detailData = { ...row, ...detail }
        })
        .catch(() => {
          // 服务端接口暂未实现，使用列表行数据回显，保证前端可正常联调
          this.detailData = { ...row }
        })
        .finally(() => {
          this.detailLoading = false
        })
    },

    onDetailClosed() {
      this.detailData = {}
      this.detailLoading = false
    },

    // Drawer 宽度 = 内容界面宽度的 50%
    calcDrawerSize() {
      const contentWidth = (this.$el && this.$el.clientWidth) || window.innerWidth
      return Math.max(Math.floor(contentWidth * 0.5), 320) + "px"
    },

    /* ============ 展示格式化 ============ */
    isCallback(row) {
      if (!row) return false
      if (row.is_callback === true) return true
      const val = String(row.is_callback).toLowerCase()
      return val === "1" || val === "true" || val === "是"
    },

    isShared(row) {
      if (!row) return false
      if (row.status === true) return true
      return String(row.status) === "1"
    },

    statusText(row) {
      if (!row) return "-"
      if (row.status_name) return row.status_name
      return this.isShared(row) ? "已分账" : "未分账"
    },

    formatAmount(val) {
      if (val === null || val === undefined || val === "") return "0.00"
      const num = Number(val)
      if (isNaN(num)) return val
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style scoped>
.pay-amount {
  color: #f56c6c;
  font-weight: 600;
}

.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.drawer-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 20px;
}

.drawer-footer {
  flex-shrink: 0;
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.detail-desc {
  margin-bottom: 12px;
}

.ret-content {
  word-break: break-all;
}

::v-deep .el-drawer__body {
  overflow: hidden;
}
</style>
